var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    { staticClass: "flex" },
    [
      _c(
        "ib-table-basic",
        {
          staticClass: "socket outsety-24 shrink",
          attrs: { data: _vm.position, root: "window", "root-margin": "256px" },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _vm.loading
                    ? _c("ib-progress-linear")
                    : _vm.error
                    ? _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("Failed_to_get_contracts")
                          ),
                        },
                      })
                    : _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.$t("No_contracts_found")),
                        },
                      }),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function (pos) {
                return [
                  _c("td", { attrs: { title: pos.ticker } }, [
                    _c("span", {
                      staticClass: "end-8 text-bold",
                      domProps: { textContent: _vm._s(pos.ticker) },
                    }),
                  ]),
                  _c("td", { attrs: { title: pos.desc } }, [
                    _vm._v(_vm._s(pos.desc)),
                  ]),
                  _c("td", {
                    directives: [
                      {
                        name: "num",
                        rawName: "v-num.raw",
                        value: _vm.posMd[88],
                        expression: "posMd[88]",
                        modifiers: { raw: true },
                      },
                    ],
                    attrs: { title: _vm.posMd[88] || "" },
                  }),
                  _c("td", {
                    directives: [
                      {
                        name: "num",
                        rawName: "v-num.raw",
                        value: _vm.posMd[84],
                        expression: "posMd[84]",
                        modifiers: { raw: true },
                      },
                    ],
                    attrs: { title: _vm.posMd[84] || "" },
                  }),
                  _c("td", {
                    directives: [
                      {
                        name: "num",
                        rawName: "v-num.raw",
                        value: _vm.posMd[86],
                        expression: "posMd[86]",
                        modifiers: { raw: true },
                      },
                    ],
                    attrs: { title: _vm.posMd[86] || "" },
                  }),
                  _c("td", {
                    directives: [
                      {
                        name: "num",
                        rawName: "v-num.raw",
                        value: _vm.posMd[85],
                        expression: "posMd[85]",
                        modifiers: { raw: true },
                      },
                    ],
                    attrs: { title: _vm.posMd[85] || "" },
                  }),
                  _c("td", {
                    directives: [
                      {
                        name: "num",
                        rawName: "v-num.raw",
                        value: _vm.time,
                        expression: "time",
                        modifiers: { raw: true },
                      },
                    ],
                    attrs: { title: _vm.time },
                  }),
                ]
              },
            },
          ]),
        },
        [
          _c("ib-table-col", { attrs: { width: "8ch" } }, [
            _vm._v(_vm._s(_vm.$t("ib_symbol")) + "    "),
          ]),
          _c("ib-table-col", { attrs: { width: "36ch" } }, [
            _vm._v(_vm._s(_vm.$t("product_description"))),
          ]),
          _c("ib-table-col", { attrs: { width: "16ch", numeric: "" } }, [
            _vm._v(_vm._s(_vm.$t("Bid_Size"))),
          ]),
          _c("ib-table-col", { attrs: { width: "16ch", numeric: "" } }, [
            _vm._v(_vm._s(_vm.$t("Bid_Price"))),
          ]),
          _c("ib-table-col", { attrs: { width: "16ch", numeric: "" } }, [
            _vm._v(_vm._s(_vm.$t("Ask_price"))),
          ]),
          _c("ib-table-col", { attrs: { width: "16ch", numeric: "" } }, [
            _vm._v(_vm._s(_vm.$t("Ask_Size"))),
          ]),
          _c("ib-table-col", { attrs: { width: "24ch", numeric: "" } }, [
            _vm._v(_vm._s(_vm.$t("time"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }